import { __decorate, __metadata, __param } from "tslib";
import { Component, Inject, Input, Output } from 'angular-ts-decorators';
import template from './pfm-pager.component.html';
var PfmPagerComponent = (function () {
    function PfmPagerComponent($timeout) {
        this.$timeout = $timeout;
    }
    PfmPagerComponent.prototype.pages = function () {
        var pageCount = Math.ceil(this.count / this.pageSize);
        var pages = [];
        for (var i = 1; i <= pageCount; i++) {
            pages.push(i);
        }
        return pages;
    };
    PfmPagerComponent.prototype.limitStart = function () {
        var numberOfVisiblePages = 3;
        return this.currentPage < numberOfVisiblePages ? 0 : this.currentPage - numberOfVisiblePages;
    };
    PfmPagerComponent.prototype.setFirstPage = function () {
        this.setPage(1);
    };
    PfmPagerComponent.prototype.setLastPage = function () {
        this.setPage(this.pages().length);
    };
    PfmPagerComponent.prototype.setNextPage = function () {
        this.setPage(this.currentPage + 1);
    };
    PfmPagerComponent.prototype.setPreviousPage = function () {
        this.setPage(this.currentPage - 1);
    };
    PfmPagerComponent.prototype.isFirstPage = function () {
        return this.currentPage === 1;
    };
    PfmPagerComponent.prototype.isCurrentPage = function (page) {
        return this.currentPage === page;
    };
    PfmPagerComponent.prototype.isLastPage = function () {
        return this.currentPage === this.pages().length;
    };
    PfmPagerComponent.prototype.setPage = function (page) {
        var _this = this;
        if (this.currentPage === page) {
            return;
        }
        this.currentPage = page;
        this.$timeout(function () { _this.pageAction(); });
    };
    PfmPagerComponent.$inject = [];
    __decorate([
        Input('='),
        __metadata("design:type", Number)
    ], PfmPagerComponent.prototype, "count", void 0);
    __decorate([
        Input('='),
        __metadata("design:type", Number)
    ], PfmPagerComponent.prototype, "currentPage", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], PfmPagerComponent.prototype, "pageSize", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Function)
    ], PfmPagerComponent.prototype, "pageAction", void 0);
    PfmPagerComponent = __decorate([
        Component({
            selector: 'pfmPager',
            template: template,
        }),
        __param(0, Inject('$timeout')),
        __metadata("design:paramtypes", [Function])
    ], PfmPagerComponent);
    return PfmPagerComponent;
}());
export { PfmPagerComponent };
